import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { AuraLayout, Layout } from "lola-framework-ui-test";
import { useStore } from "../store/globalState";
import { flavorClassName } from "../constants";
import { LEGAL_DOC_KEYS, type LegalDocKey } from "../constants/legal";
import { LegalAccordion } from "../components/legal/LegalAccordion";
import { LegalContent } from "../components/legal/LegalContent";
import "../styles/legal.style.css";
import { getEvents, safeCapture } from "../analytics";
import { ScrollFadeIndicator } from "../components/ScrollFadeIndicator";
import { Navbar } from "../components/Navbar";


export const LegalPage = () => {
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    safeCapture(getEvents().LEGAL_VIEW);
  }, []);

  const docParam = searchParams.get("doc") as LegalDocKey | null;
  const excludeParam = searchParams.get("exclude") as LegalDocKey | null;

  const filteredDocs = excludeParam
    ? LEGAL_DOC_KEYS.filter((k) => k !== excludeParam)
    : LEGAL_DOC_KEYS;

  const title = docParam ? t(`legal.docs.${docParam}`) : t("legal.title");

  return (
    <AuraLayout
      colorConfig={colorConfig}
      className={`white-view-background legal-page ${flavorClassName}`}
    >
      <Layout.Header>
        <Navbar
          onBackClick={() => navigate(-1)}
          title={title}
          align="center"
        />
      </Layout.Header>
      <Layout.Content isOverflowauto>
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="legal-wrapper">
          {docParam ? (
            <LegalContent doc={docParam} />
          ) : (
            <LegalAccordion docs={filteredDocs} />
          )}
        </section>
      </Layout.Content>
    </AuraLayout>
  );
};
